// extracted by mini-css-extract-plugin
export default {"select":"Select_select__b89VJ","selectDisabled":"Select_selectDisabled__xVba9"};